import { render, staticRenderFns } from "./StockBalance.vue?vue&type=template&id=671dba64&scoped=true"
import script from "./StockBalance.vue?vue&type=script&lang=js"
export * from "./StockBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671dba64",
  null
  
)

export default component.exports